import React, { useContext } from "react";
import {
  Container,
  Stack,
  IconButton,
  Button,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import { Link } from "react-router-dom";
import { AppContext } from "../../utils";
import CustomDrawer from "./CustomDrawer";
function Navbar() {
  const mobile = useMediaQuery("(max-width:1050px)");
  const { account, connect, disconnect } = useContext(AppContext);

  return (
    <div
      style={{
        background: "#21123F",
        margin: "auto",
      }}
    >
      <Container maxWidth="xl">
        <Stack
          width="100%"
          direction={"row"}
          alignItems="center"
          justifyContent={"space-between"}
          sx={{ height: mobile ? "70px" : "100px" }}
        >
          {/* Icons  */}

          <Stack alignItems={"center"} direction="row" spacing={mobile ? 1 : 2}>
            <a
              href="https://twitter.com/contexiafinance"
              target="_blank"
              style={{ textDecoration: "none", cursor: "pointer" }}
            >
              <IconButton
                sx={{
                  color: "#FAA631",
                  "&:hover": {
                    color: "white",
                  },
                }}
              >
                {" "}
                <i
                  className="white"
                  class="fa-brands fa-twitter"
                  style={{
                    fontSize: mobile ? "16px" : "30px",
                    cursor: "pointer",
                  }}
                ></i>{" "}
              </IconButton>
            </a>

            <a
              href="https://medium.com"
              target="_blank"
              style={{ textDecoration: "none", cursor: "pointer" }}
            >
              <IconButton
                sx={{
                  color: "#FAA631",
                  "&:hover": {
                    color: "white",
                  },
                }}
              >
                {" "}
                <i
                  class="fa-brands fa-medium"
                  style={{
                    fontSize: mobile ? "16px" : "30px",
                    cursor: "pointer",
                  }}
                ></i>
              </IconButton>
            </a>
            <a
              href="https://discord.gg/contexiafinance"
              target="_blank"
              style={{ textDecoration: "none", cursor: "pointer" }}
            >
              <IconButton
                sx={{
                  color: "#FAA631",
                  "&:hover": {
                    color: "white",
                  },
                }}
              >
                {" "}
                <i
                  class="fa-brands fa-discord"
                  style={{
                    fontSize: mobile ? "16px" : "30px",
                    cursor: "pointer",
                  }}
                ></i>
              </IconButton>
            </a>
          </Stack>

          {mobile ? (
            <>
              <Box pb="20px" pr="20px">
                <CustomDrawer />
              </Box>
            </>
          ) : (
            <></>
          )}

          {mobile ? (
            <>
              {account ? (
                <Button
                  sx={{
                    fontSize: "15px",
                    background: "#FAA631",
                    "&:hover": {
                      background: "white",
                      color: "#FAA631",
                    },
                    color: "white",
                    borderRadius: "10px",
                    height: "30px",
                    fontFamily: "light",
                  }}
                  onClick={() => disconnect()}
                >
                  {account.slice(0, 6)}... {account.slice(-4)}
                </Button>
              ) : (
                <Button
                  sx={{
                    fontSize: "15px",
                    width: "94px",
                    background: "#FAA631",
                    "&:hover": {
                      background: "white",
                      color: "#FAA631",
                    },
                    color: "white",
                    borderRadius: "10px",
                    height: "30px",
                    fontFamily: "light",
                  }}
                  onClick={connect}
                >
                  Connect
                </Button>
              )}
            </>
          ) : (
            <>
              {/* LInks  */}

              <Stack alignItems={"center"} direction="row" spacing={3}>
                <Link to="/" style={{ textDecoration: "none" }}>
                  <IconButton>
                    {" "}
                    <Box
                      sx={{
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#FAA631",
                        "&:hover": {
                          color: "white",
                        },
                        "&:active": {
                          color: "white",
                        },
                        fontFamily: "semi",
                      }}
                    >
                      DASHBORD
                    </Box>{" "}
                  </IconButton>
                </Link>
                <Link to="/store" style={{ textDecoration: "none" }}>
                  <IconButton>
                    <Box
                      sx={{
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#FAA631",
                        "&:hover": {
                          color: "white",
                        },
                        "&:active": {
                          color: "white",
                        },
                        fontFamily: "semi",
                      }}
                    >
                      STORE
                    </Box>{" "}
                  </IconButton>
                </Link>
                <Link to="/stake" style={{ textDecoration: "none" }}>
                  <IconButton>
                    <Box
                      sx={{
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#FAA631",
                        "&:hover": {
                          color: "white",
                        },
                        "&:active": {
                          color: "white",
                        },
                        fontFamily: "semi",
                      }}
                    >
                      STAKE
                    </Box>{" "}
                  </IconButton>
                </Link>

                <Link to="/swap" style={{ textDecoration: "none" }}>
                  <IconButton>
                    <Box
                      sx={{
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#FAA631",
                        "&:hover": {
                          color: "white",
                        },
                        "&:active": {
                          color: "white",
                        },
                        fontFamily: "semi",
                      }}
                    >
                      SWAP
                    </Box>{" "}
                  </IconButton>
                </Link>
              </Stack>

              {/* Buttons  */}

              <Stack alignItems={"center"} direction="row" spacing={3}>
                <Button
                  className=".fam"
                  sx={{
                    fontSize: "25px",
                    width: "176px",
                    background: "#FAA631",
                    "&:hover": {
                      background: "white",
                      color: "#FAA631",
                    },
                    color: "white",
                    borderRadius: "10px",
                    height: "43px",
                    fontFamily: "light",
                  }}
                >
                  buy $CON
                </Button>
                {account ? (
                  <Button
                    sx={{
                      fontSize: "25px",
                      background: "#FAA631",
                      "&:hover": {
                        background: "white",
                        color: "#FAA631",
                      },
                      color: "white",
                      borderRadius: "10px",
                      height: "43px",
                      fontFamily: "light",
                    }}
                    onClick={() => disconnect()}
                  >
                    {account.slice(0, 6)}... {account.slice(-4)}
                  </Button>
                ) : (
                  <Button
                    sx={{
                      fontSize: "25px",
                      width: "176px",
                      background: "#FAA631",
                      "&:hover": {
                        background: "white",
                        color: "#FAA631",
                      },
                      color: "white",
                      borderRadius: "10px",
                      height: "43px",
                      fontFamily: "light",
                    }}
                    onClick={connect}
                  >
                    Connect
                  </Button>
                )}
              </Stack>
            </>
          )}
        </Stack>
      </Container>
    </div>
  );
}

export default Navbar;
